/** Chart color schemes for Recharts components. */

export type ChartColorScheme = 'classic' | 'high-contrast' | 'colorblind';

export interface ChartPalette {
  primary: string;
  positive: string;
  negative: string;
  neutral: string;
  series: string[];
  grid: string;
  tooltip: string;
}

const PALETTES: Record<ChartColorScheme, ChartPalette> = {
  classic: {
    primary: '#2dd4bf',
    positive: '#22c55e',
    negative: '#ef4444',
    neutral: '#94a3b8',
    series: ['#2dd4bf', '#60a5fa', '#f59e0b', '#a78bfa', '#fb7185', '#34d399'],
    grid: 'rgba(148,163,184,0.1)',
    tooltip: '#1e293b',
  },
  'high-contrast': {
    primary: '#ffffff',
    positive: '#00ff88',
    negative: '#ff3333',
    neutral: '#cccccc',
    series: ['#ffffff', '#ffff00', '#00ffff', '#ff00ff', '#ff8800', '#00ff00'],
    grid: 'rgba(255,255,255,0.15)',
    tooltip: '#000000',
  },
  colorblind: {
    primary: '#0077bb',
    positive: '#009988',
    negative: '#cc3311',
    neutral: '#bbbbbb',
    series: ['#0077bb', '#33bbee', '#009988', '#ee7733', '#cc3311', '#ee3377'],
    grid: 'rgba(187,187,187,0.15)',
    tooltip: '#1e293b',
  },
};

export function getChartPalette(scheme: ChartColorScheme): ChartPalette {
  return PALETTES[scheme] ?? PALETTES.classic;
}
